
import {styled} from '@mui/material/styles';
import Container from '@mui/material/Container';
// import CircularProgress from '@mui/material/CircularProgress';
// // import Alert from '@mui/material/Alert';
import { useTranslation } from 'react-i18next';

import { 
    WhiteSpace,
    Button,
    TextLinear,
    TextMax,
    TextM,
    TextS,
    Hr,
    Input,
    Card,
    FlexBLock,
    LoadingBlock,
    Tips
} from '../../components';

import {IconImg} from '../../components/Icon'

import {
    EtherToInt,
} from '../../ethers/e'

import {
    useStairData,
    useBuyOrder,
    useClaimStair,
    useWithdrawOrder,
    useReInvestOrder
} from '../../hook/v2/useNode'

import useCountdown from '../../hook/useCountdown'

import {
    useBalance
} from '../../context/balance'
import { useEffect } from 'react';

import {ProtocolSignDrawer} from '../Protocol'


function ComingSoon() {
    const {t} = useTranslation()
    return <Button type='b' style={{width: '100%'}}>{t('Coming Soon')}</Button>
}

function BuyStairsSwitch({stair}) {
    /** 当 url 为 stair 时 用 Buystairs ，否则 用 comingsoon 组建 */
    // const urlParams = getUrl()

    // console.log(urlParams)
    return (
        // <ComingSoon />
        
        // urlParams === null ?
        // <ComingSoon /> :
        // {/* <ComingSoon /> */}
        <BuyStairs
            sponsor={stair.sponsor}
            principal={stair.totalPrincipal}
            initialVip={stair.initialVip}
            initialVipRate={stair.initialVipRate}
            maxInvestable={stair.maxInvestable}
        />
    )
}

function BuyStairs({sponsor, principal, initialVip, initialVipRate, maxInvestable}) {
    const {t} = useTranslation()
    const {balances} = useBalance() 
    const {
        button,
        buttonCVCD,
        amountInput,
        sponsorInput,
        hashInput
    } = useBuyOrder()

    const registed = sponsor*1 > 0
    useEffect(() => {
        if (sponsor*1 > 0) {
            sponsorInput.onChange(sponsor)
        }
    }, [sponsor])

    const requireSign = hashInput.value === '' && !registed

    const disableBuy = amountInput.value*1 > maxInvestable*1
    buttonCVCD.disabled = amountInput.value*1 > balances.CVCD*2 ||  amountInput.value*1 > 2 * balances.USDT || disableBuy
    button.disabled = balances.USDT*1 < amountInput.value*1 || disableBuy


    return (
        <>
            <TextS>{t('Balance')} <TextLinear>{EtherToInt(balances.USDT)}</TextLinear> USDT · <TextLinear linear='2'>{EtherToInt(balances.CVCD)}</TextLinear> CVCD</TextS>
            <Input
                after={<Button size='small' type='d' onClick={()=>{
                    const max = Math.min(balances.USDT, balances.CVCD)
                    amountInput.onChange(Math.max(balances.USDT, max*2))
                }}>{t('Max')}</Button>}
                input={amountInput}
            />
            {
                disableBuy && <TextS fail>{t('Max')} {EtherToInt(maxInvestable)}</TextS>
            }

            <WhiteSpace />
            <FlexBLock>
                <TextS color='2'>{t('Stair Invested')}</TextS>
                <TextS>{EtherToInt(principal)} <TextS color='2'>CVCD·USDT</TextS></TextS>
            </FlexBLock>
            <FlexBLock>
                <TextS color='2'>{t('Initial Level')}</TextS>
                <TextS><NodeType>VIP{initialVip}</NodeType> <NodeType i='2'>+{initialVipRate}%</NodeType></TextS>
            </FlexBLock>
            
            {
                !registed && 
                <>
                    <TextS>{t('Sponsor Address')}</TextS>
                    <Input
                        input={sponsorInput}
                    />
                </>
            }

            
            <WhiteSpace />
            {

                requireSign ? 
                <ProtocolSignDrawer
                    buttonStyle={{
                        type:'b',
                        style: {width: '100%'}
                    }}
                    onComfirm={hash => {
                        hashInput.onChange(hash)
                    }}
                />:
                // <FlexBLock>
                //     <Button type='b' style={{width: '49%'}} {...buttonCVCD} />
                //     <Button type='d' style={{width: '49%'}} {...button} />
                // </FlexBLock>
                <Button type='b' style={{width: '100%'}}>{t('Updating')}</Button>
            }
        </>
    )
}


function Countdown({end, children}) {
    const {t} = useTranslation()
    const countdown = useCountdown(end, (hours, minutes, seconds) => {
        let days = Math.floor(hours / 24)
        return `${days > 0 ? days+t('D'): ''} ${hours % 24}:${minutes}:${seconds} `
    })
    return countdown === 'Ended' ? children : <TextS style={{fontSize: '16px'}}>{countdown}</TextS>
}

function SetOrder({id, vip, upgradeLimited}) {
    const wButton = useWithdrawOrder(id)
    const rButton = useReInvestOrder(id)

    return (
        <>
            <Button size='small' style={{marginRight: '4px'}} {...wButton}/>
            {/* { vip === 52 ? null : <Button size='small' type={upgradeLimited ? 'e' : 'd'} {...rButton} disabled={upgradeLimited || rButton.disabled}/> } */}
        </>
    )
}

function UpgradeLimitNotice({remaining, excess}) {
    const {t} = useTranslation()
    return (
        <LimitNotice>
            <TextS color='2' block>
                {t('Static reward remaining')} <TextS>{EtherToInt(remaining)}</TextS> CVCD.
            </TextS>
            <TextS color='2' block>
                {t('This order exceeds the limit by')} <TextS>{EtherToInt(excess)}</TextS> CVCD, {t('so it cannot be reinvested.')}
            </TextS>
        </LimitNotice>
    )
}

function ClaimButton() {
    return <Button {...useClaimStair()}/>
}

function Stairs() {
    const {t} = useTranslation()
    const stair = useStairData()
    console.log(
        stair
    )
    return (
        <Container>
            <TextMax><IconImg style={{width: '26px', height: 'auto', verticalAlign: 'inherit'}} src='./pyramid.png'/> {t('Ladder Program V2')}</TextMax>
            <WhiteSpace />
            <Card type='j'>
                <FlexBLock>
                    <div>
                        <TextM block>{t('My Stair Differential Reward')}</TextM>
                        <TextLinear style={{fontSize: '24px'}} block>{EtherToInt(stair.claimStair)}</TextLinear> <TextM color='2'> / CVCD</TextM>
                        {/* <TextS color='2' block>My Total Reward <TextS >{EtherToInt(stair.totalRewarded)}</TextS> CVCD</TextS> */}
                        <TextS color='2' block>{t('Differential Reward Balance')} <TextS>{EtherToInt(stair.unlockable)}</TextS> CVCD</TextS>
                    </div>
                    <ClaimButton />
                </FlexBLock>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                {
                    stair.fee * 1 > 0 && 
                    <FlexBLock>
                        <TextS color='2'>{t('Invest Fee Reward')} </TextS>
                        <TextS>{EtherToInt(stair.fee)} <TextS color='2'>CVCD</TextS></TextS>
                    </FlexBLock>
                }
                <FlexBLock>
                    <TextS color='2'>{t('Cumulative Differential Profit')}</TextS>
                    <TextS>{EtherToInt(stair.totalOrderRewarded)} <TextS color='2'>CVCD</TextS></TextS>
                </FlexBLock>
                <FlexBLock>
                    <TextS color='2'>{t('Max Differential Profit')} <Tips type='a'>X3</Tips></TextS>
                    <TextS>{EtherToInt(stair.orderNetTnvest)} <TextS color='2'>CVCD</TextS></TextS>
                </FlexBLock>
                <FlexBLock>
                    <TextS color='2'>{t('My Level')} </TextS>
                    <TextS><NodeType>VIP{stair.vip}</NodeType> <NodeType i='2'>+{stair.vipRate}%</NodeType></TextS>
                </FlexBLock>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <BuyStairsSwitch stair={stair}/>
            </Card>
            <WhiteSpace />
            <Card>
                <TextM block>{t('My Orders Total locked')}</TextM>
                {/* <WhiteSpace /> */}
                <TextLinear style={{fontSize: '24px'}} block>{EtherToInt(stair.totalLocked)}</TextLinear> <TextM color='2'> / CVCD</TextM>
                <WhiteSpace size={.4} />
                <FlexBLock>
                    <TextS color='2'>{t('Total Principal')}</TextS>
                    <TextS>{EtherToInt(stair.totalPrincipal)} <TextS color='2'>CVCD</TextS></TextS>
                </FlexBLock>
                <FlexBLock>
                    <TextS color='2'>{t('Static Net Profit')}</TextS>
                    <TextS>{EtherToInt(stair.staticNetProfit)} <TextS color='2'>CVCD</TextS></TextS>
                </FlexBLock>
                {/* <TextS color='2'>Total locked <TextLinear>{EtherToInt(stair.totalLocked)}</TextLinear> CVCD</TextS> */}
                {/* <FlexBLock>
                    <TextS color='2'>Total locked</TextS>
                    <TextS><TextLinear>{EtherToInt(stair.totalLocked)}</TextLinear> CVCD</TextS>
                </FlexBLock> */}
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <LoadingBlock loading={stair.registed === null}>
                    {
                        stair.orders.filter(v => !v.closed && v.invested*1 > 0).map(v => {
                            return (
                                <div key={v.id}>
                                    <FlexBLock style={{padding: '6px 0 12px'}}>
                                        <div>
                                            <TextS block color='2'>{t('Position')} <NodeType>VIP{v.vip}</NodeType> <NodeType i='2'>+{v.vipRate}%</NodeType></TextS>
                                            <TextM style={{margin: '2px 0px'}}>{EtherToInt(v.invested)} <TextS color='2'>CVCD</TextS></TextM>
                                            <TextS style={{margin: '2px 0px'}} block color='2'>{t('Principal')} <TextS>{EtherToInt(v.initialInvest)} </TextS>CVCD</TextS>
                                            <TextS block color='2'>{t('Start Time')} : {v.startDate}</TextS>
                                            <NodeType i='2'>{v.cycle} {t('Round')}</NodeType>
                                        </div>
                                        {
                                            v.closed ?
                                            <TextM color='2'>{t('Ended')}</TextM>:
                                            <div>
                                                <Countdown end={v.unlockEnd}>
                                                    <SetOrder id={v.id} vip={v.vip} upgradeLimited={v.upgradeLimited}/>
                                                    {/* <Button size='small'>{t("Updating")}</Button> */}
                                                </Countdown>
                                                {/* <SetOrder id={v.id} vip={v.vip}/> */}
                                                {/* <SetOrder id={v.id} vip={v.vip} upgradeLimited={v.upgradeLimited}/> */}
                                                {/* <Button size='small'>{t("Updating")}</Button> */}
                                            </div>
                                        }
                                    </FlexBLock>
                                    {/* {
                                        !v.closed && v.upgradeLimited &&
                                        <UpgradeLimitNotice
                                            remaining={v.upgradeRemaining}
                                            excess={v.upgradeExcess}
                                        />
                                    } */}
                                    <Hr />
                                </div>
                            )
                        })
                    }
                </LoadingBlock>
            </Card>
        </Container>
    )
}

export default Stairs

const COLOR = [
    "rgb(171 255 0)",
    "rgb(255 199 0)",
    "rgb(255 241 0)",
    "rgb(255 0 161)",
    "rgb(0 242 255)",
]
function NodeType({children, i = 0}) {
    return <NodeBlock i={i}>{children}</NodeBlock>
}

const NodeBlock = styled('span')`
    background-color: ${p => COLOR[p.i] || COLOR[0]};
    color: #000;
    font-size: 10px;
    padding: 2px 4px;
    border-radius: 4px;
    margin-left: 4px;
    box-shadow: 0px 0px 6px #fdffb791;
`

const LimitNotice = styled('div')`
    margin: -4px 0 12px;
    padding: 8px 10px;
    border-radius: 8px;
    background: rgb(255 241 0 / 8%);
    border: 1px solid rgb(255 241 0 / 22%);
`
